import { render } from "./UpdatedEmail.vue?vue&type=template&id=c5e8fd4c"
import script from "./UpdatedEmail.vue?vue&type=script&lang=js"
export * from "./UpdatedEmail.vue?vue&type=script&lang=js"

import exportComponent from "/home/circleci/project/frontend/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__